import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
    fallbackLng: 'en',
    lng: 'nl',
    resources: {
        en: {
            translations: require('./locales/en.json')
        },
        nl: {
            translations: require('./locales/nl.json')
        }
    },
    ns: ['translations'],
    defaultNS: 'translations'
});

i18n.languages = ['nl', 'en'];

export default i18n;
